export const SANDBOX_PREDEFINED_VALUES: ValidSandbox[] = [
    'allow-forms',
    'allow-popups',
    'allow-popups-to-escape-sandbox',
    'allow-same-origin',
    'allow-scripts',
    'allow-top-navigation-by-user-activation',
    'allow-top-navigation-to-custom-protocols',
];

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/iframe#sandbox
 */
export const VALID_SANDBOX = new Set([
    'allow-downloads',
    'allow-forms',
    'allow-modals',
    'allow-orientation-lock',
    'allow-pointer-lock',
    'allow-popups',
    'allow-popups-to-escape-sandbox',
    'allow-presentation',
    'allow-same-origin',
    'allow-scripts',
    'allow-storage-access-by-user-activation',
    'allow-top-navigation',
    'allow-top-navigation-by-user-activation',
    'allow-top-navigation-to-custom-protocols',
] as const);

type ValidSandboxIterator = ReturnType<(typeof VALID_SANDBOX)['values']>;
export type ValidSandbox = ValidSandboxIterator extends Iterator<infer T> ? T : never;

export const assertsValidSandbox = (sandbox: string): asserts sandbox is ValidSandbox => {
    if (!VALID_SANDBOX.has(sandbox as ValidSandbox)) {
        throw new Error(`Invalid sandbox value: "${sandbox}"`);
    }
};
